<div [class.row]="!inline" [class.search-filter-row]="!inline" [style.display]="inline ? 'inline-flex': 'flex'">
  <div class="search-input-wrapper">
    <input [class.collapsed]="collapsed" [class.table-filter-input-simple]="simple" [class.table-filter-input]="!simple" (keyup)="keyupEvent.emit($event)"
      [placeholder]="placeholder" #searchField/>
    <i class="material-icons global-search-icon" (click)="collapse()" [class.collapsable]="collapsable">&#xE8B6;</i>
  </div>
</div>